import { Avatar, Flex, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"

import { ButtonComponent } from "../../../../Components/Button"
import Private, { INCOGNITO_MASK } from "../../../../Components/Private"
import { collapseRowCell } from "../../../../Components/Table/baseColumns"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import { isIncognitoActive } from "../../../../Utils/incognito"
import { dateFormat, statusTextMap, tagMap } from "../../../../Utils/utils"

const { Text, Paragraph } = Typography

export const columns = ({ onSelectRow, t, data, isAdmin, externalDemoMode }) => {
  const sequenceNumberList = [...data]?.map(({ sequence_number }) => sequence_number)
  const nameList = [...data]?.map(({ name }) => name)
  const emailList = [...data]?.map(({ email }) => email)

  return [
    {
      key: "sequence_number",
      title: (state) =>
        titleSortFilters({
          title: null,
          //icon: alertsColumnIconMap['sequence_number'],
          stateData: state,
          key: "sequence_number"
        }),
      dataIndex: "sequence_number",
      width: 80,
      fixed: "left",
      onCell: (record, index) => {
        const key = "sequence_number"
        const countDuplicates = sequenceNumberList?.filter((name) => name === record?.[key])?.length
        return collapseRowCell({
          value: record?.[key],
          index,
          prevValue: index ? data[index - 1]?.[key] : null,
          countDuplicates
        })
      }
    },
    {
      key: "name",
      title: t("Name"),
      dataIndex: "name",
      fixed: "left",
      minWidth: 140,
      render: (_) => <Private>{_}</Private>,
      onCell: (record, index) => {
        const key = "sequence_number"
        const countDuplicates = sequenceNumberList?.filter((name) => name === record?.[key])?.length
        return collapseRowCell({
          value: record?.[key],
          index,
          prevValue: index ? data[index - 1]?.[key] : null,
          countDuplicates
        })
      }
    },
    {
      key: "email",
      title: t("Email"),
      dataIndex: "email",
      minWidth: 160,
      render: (_) => <Private>{_}</Private>,
      onCell: (record, index) => {
        const key = "email"
        const countDuplicates = emailList?.filter((email) => email === record?.[key])?.length
        return collapseRowCell({
          value: record?.[key],
          index,
          prevValue: index ? data[index - 1]?.[key] : null,
          countDuplicates
        })
      }
    },
    {
      key: "role",
      title: t("Role"),
      dataIndex: "role",
      minWidth: 124,
      width: 124,
      render: (_) => _?.name
    },
    {
      key: "access_granted",
      title: t("Access granted"),
      dataIndex: "access_granted",
      width: 260,
      render: (_) => (
        <Tag
          bordered={false}
          color="processing"
          wrap="nowrap"
          style={{ fontSize: 14, padding: "3px 8px", borderRadius: 14 }}
        >
          <Flex gap={4} align="center">
            <Avatar
              size={16}
              src={_?.photo}
              style={{
                backgroundColor: _?.photo ? "transparent" : "#225AEA",
                borderRadius: "4px",
                border: "none",
                fontSize: 12,
                lineHeight: 1
              }}
              {...(_?.photo && { src: _?.photo })}
            >
              {!_?.photo ? _?.name?.[0] || "" : null}
            </Avatar>
            <Paragraph
              ellipsis={{
                rows: 1,
                expandable: true,
                tooltip: isIncognitoActive() ? INCOGNITO_MASK : _?.name,
                symbol: null
              }}
              style={{ margin: 0, maxWidth: 220 }}
            >
              <Private>{_?.name}</Private>
            </Paragraph>
          </Flex>
        </Tag>
      )
    },
    {
      key: "status",
      title: t("Status"),
      dataIndex: "status",
      width: 140,
      render: (_, { status }) => {
        return (
          <Tag
            bordered={false}
            color={tagMap[status?.toLowerCase()] || "default"}
            key={status}
            style={{ margin: 0 }}
            className={"large color-text"}
          >
            <Flex gap={8} align="center">
              {/*<Badge status={tagMap[status?.toLowerCase()] || 'default'} color={tagColorMap[status]}/>*/}
              <Text>{statusTextMap[status] || status}</Text>
            </Flex>
          </Tag>
        )
      }
    },
    {
      key: "last_active",
      sorter: true,
      title: t("Last active"),
      dataIndex: "last_active",
      width: 185,
      render: (_) =>
        _ ? (
          <Space direction="vertical" size={4}>
            <Text>{dayjs(_).format(dateFormat)}</Text>
            <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
          </Space>
        ) : (
          <Text type="secondary">{t("No activity")}</Text>
        )
    },
    {
      key: "action",
      title: t("Actions"),
      width: 120,
      render: (_, record) => {
        const handleAction = (e, data, type) => {
          e.preventDefault()
          e.stopPropagation()
          onSelectRow(data, type)
        }

        if (record?.role === "Owner" || externalDemoMode) return null

        return (
          <Flex gap={4} justify="flex-end">
            {record?.status?.toLowerCase() === "invited" && (
              <Tooltip title={t("Resend")}>
                <ButtonComponent
                  type="text"
                  shape="circle"
                  icon={<Icon type={"arrows_repeat"} />}
                  onClick={(e) => handleAction(e, record, "resend")}
                  className="flex center table-action-btn"
                />
              </Tooltip>
            )}

            {record?.role?.id === 1 ? null : (
              <>
                <Tooltip title={t("Edit")}>
                  <ButtonComponent
                    type="text"
                    shape="circle"
                    icon={<Icon type={"settings"} />}
                    onClick={(e) => handleAction(e, record, "edit")}
                    className="flex center table-action-btn"
                  />
                </Tooltip>

                <Tooltip title="Delete">
                  <ButtonComponent
                    danger
                    type="link"
                    shape="circle"
                    icon={<Icon type="delete" />}
                    onClick={(e) => handleAction(e, record, "delete")}
                    className="flex center table-action-btn"
                  />
                </Tooltip>
              </>
            )}
          </Flex>
        )
      }
    }
  ]
}
